import { render } from "./SkinDress.vue?vue&type=template&id=4ec02776&scoped=true"
const script = {}

import "./SkinDress.vue?vue&type=style&index=0&id=4ec02776&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec02776"]])

export default __exports__